module.exports = __webpack_public_path__ + "img/上聯_LOGO_320x150.5ddad5f8.png";